<nz-spin [nzSpinning]="spinMain">
  <div nz-row>
    <div nz-col nzSpan="24">
      <span style="font-weight: 600; font-size: 16px">Manage Work logs</span>
      <div nz-row nzGutter="12">
        <div nz-col nzSpan="8">
          <div nz-row class="my-box">
            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label nzRequired nzNoColon>Project</nz-form-label>
                <nz-form-control>
                  <nz-select name="projectName" nzShowSearch [nzLoading]="isListLoading"
                    nzPlaceHolder="Select a Project" [(ngModel)]="PROJECT_ID"
                    (ngModelChange)="radioButtonChange($event)" nzAllowClear="true">
                    <nz-option *ngFor="let project of projectList" [nzValue]="project.PROJECT_ID"
                      [nzLabel]="project.NAME">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label nzRequired nzNoColon>Module</nz-form-label>

                <nz-form-control>
                  <nz-select name="subtaskModuleName" nzShowSearch nzAllowClear [nzLoading]="isSubtaskModuleLoading"
                    nzPlaceHolder="Select a Module" (ngModelChange)="loadAllSubtaskFeatures($event)"
                    [(ngModel)]="SUBTASK_MODULE_ID">
                    <nz-option *ngFor="let module of moduleList" [nzValue]="module.ID" [nzLabel]="module.NAME">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label nzRequired nzNoColon>Feature</nz-form-label>
                <nz-form-control>
                  <nz-select name="subtaskFeatureName" nzShowSearch nzAllowClear [nzLoading]="isSubtaskFeatureLoading"
                    nzPlaceHolder="Select a Feature" (ngModelChange)="loadAllParentTasks($event)"
                    [(ngModel)]="SUBTASK_FEATURE_ID">
                    <nz-option *ngFor="let feature of subtaskFeatureList" [nzValue]="feature.ID"
                      [nzLabel]="feature.NAME">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label nzRequired nzNoColon>Task</nz-form-label>
                <nz-form-control>
                  <nz-select name="parentTask" nzShowSearch nzAllowClear [nzLoading]="isSubtaskParentTaskLoading"
                    nzPlaceHolder="Select a Parent Task" [(ngModel)]="PARENT_TASK_ID"
                    (ngModelChange)="fillTaskSubtaskWise($event)">
                    <nz-option *ngFor="let task of parentTaskList" [nzValue]="task.ID" [nzLabel]="task.NAME">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
              <nz-form-item>
                <div style="display: flex; justify-content: space-between">
                  <nz-form-label nzNoColon>Sub Task</nz-form-label>
                  <div>
                    <button nz-button nzType="primary" style="
                        margin-right: 0px;
                        padding: 1px 10px !important;
                        height: 24px !important;
                        font-size: 12px;
                        display: flex;
                        text-align: center;
                        border-radius: 20px;
                        margin-top: 4px;
                      " nzTooltipTitle="Add Sub Task" nzTooltipPlacement="top" nz-tooltip (click)="addSubTask()">
                      + Add
                    </button>
                  </div>
                </div>
                <nz-form-control>
                  <nz-select name="parentTbvghask" nzShowSearch nzAllowClear [nzLoading]="isSubtasksubTaskLoading"
                    nzPlaceHolder="Select a Sub Task" [(ngModel)]="SUBTASK_PARENT_TASK_ID">
                    <nz-option *ngFor="let task of parentsubTaskList" [nzValue]="task.ID" [nzLabel]="task.NAME">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>
        <div nz-col nzSpan="16" style="height: 75vh; overflow-y: scroll; overflow-x: hidden">
          <form nz-form #worklogPage="ngForm">
            <div nz-row class="my-box">
              <!-- <div nz-col nzSpan="24">
                                <p *ngIf="showtrue && worklogDrawerData.ID" style="font-weight: 600;
                            margin-bottom: 4px;
                            text-align: center;">Update Work log</p>
                                <p *ngIf="!worklogDrawerData.ID" style="font-weight: 600;
                            margin-bottom: 4px;
                            text-align: center;">Add Work log</p>
                            </div> -->

              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label nzRequired nzNoColon>Start Datetime</nz-form-label>
                  <nz-form-control>
                    <nz-date-picker #startDatePicker1 style="width: 100%" name="updatedDate" nzShowTime
                      [nzDisabledDate]="disabledStartDate" nzPlaceHolder="Select Start Datetime"
                      [nzShowTime]="{ nzFormat: 'hh:mm a' }" nzFormat="dd/MM/yyyy hh:mm a"
                      [(ngModel)]="worklogDrawerData.WORKED_DATETIME" (nzOnOpenChange)="moduleStartDateHandle($event)"
                      (ngModelChange)="startDateChange()">
                    </nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label nzRequired nzNoColon>End Datetime</nz-form-label>
                  <nz-form-control>
                    <nz-date-picker #moduleEndDatePicker style="width: 100%" name="endDate" nzShowTime
                      [nzDisabledDate]="disabledEndDate" nzPlaceHolder="Select End Datetime"
                      [nzShowTime]="{ nzFormat: 'hh:mm a' }" nzFormat="dd/MM/yyyy hh:mm a"
                      [(ngModel)]="worklogDrawerData.END_DATETIME" (nzOnOpenChange)="moduleEndDateHandle($event)"
                      (ngModelChange)="endDateChange()">
                    </nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- <div nz-col nzSpan="12">
                            <nz-form-item>
                                <nz-form-label nzNoColon>Time Spent</nz-form-label>
                                <nz-form-control>
                                    <b><span>{{data.SPENT_HOURS}}h {{data.SPENT_MINUTES}}m {{data.SPENT_SECONDS}}s</span></b>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
            
                        <div nz-col nzSpan="12" *ngIf="estimatedTime_Mandays== 'T'">
                            <nz-form-item>
                                <nz-form-label nzNoColon>Estimated Time</nz-form-label>
            
                                <nz-form-control>
                                    <b><span>{{estimatedHH}}h {{estimatedMM}}m {{estimatedSS}}s</span></b>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
            
                        <div nz-col nzSpan="12" *ngIf="estimatedTime_Mandays== 'M'">
                            <nz-form-item>
                                <nz-form-label nzNoColon>Estimated Mandays</nz-form-label>
            
                                <nz-form-control>
                                    <b><span>{{estimatedMandays}}</span></b>
                                </nz-form-control>
                            </nz-form-item>
                        </div> -->

              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label nzRequired nzNoColon>Description
                    <span *ngIf="worklogDrawerData.WORK_DESCRIPTION" style="
                        font-size: 10px;
                        color: red;
                        font-weight: 500;
                        margin-left: 10px;
                      ">({{ worklogDrawerData.WORK_DESCRIPTION.length }}/
                      500)</span></nz-form-label>

                  <nz-form-control nzHasFeedback nzErrorTip="Work Description is Required">
                    <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 5 }" #startDatePicker name="workDescription"
                      placeHolder="Enter a Work Description" [(ngModel)]="worklogDrawerData.WORK_DESCRIPTION"
                      maxlength="500" required></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24" style="text-align: right; margin-top: 5px">
                <button type="button" nz-button class="ant-btn" style="margin-right: 8px" [nzLoading]="isSpinning"
                  (click)="resetDrawer(worklogPage)">
                  <span>Cancel</span>
                </button>
                <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning"
                  nzType="primary" *ngIf="worklogDrawerData.ID" (click)="save(false, worklogPage)">
                  <span>Update Work log </span>
                </button>
                <button type="button" class="ant-btn ant-btn-primary" *ngIf="!worklogDrawerData.ID" nzType="primary"
                  nz-button [nzLoading]="isSpinning" (click)="save(false, worklogPage)">
                  <span>Submit Work log</span>
                </button>
                <!-- <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu>
                                    <li nz-menu-item class="menuc"
                                        style="border-radius: 4px;background-color: #40a9ff;">
                                        <a (click)="save(true, worklogPage)">Save & New</a>
                                    </li>
                                </ul>
                            </nz-dropdown-menu> -->
              </div>
            </div>
          </form>
          <div nz-row class="my-box">
            <div nz-col nzSpan="24">
              <div style="display: flex; justify-content: space-between">
                <div style="
                    font-weight: 600;
                    margin-bottom: 4px;
                    display: flex;
                    align-items: center;
                  ">
                  MY Work logs&nbsp;<span style="font-size: 12px;display: contents;" *ngIf="worklogcount > 0">(Total
                    Hours :
                    {{totalhours}}hrs {{totalminutes}}min
                    {{totalseconds}}sec)</span>
                </div>

                <div style="display: flex">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-date-picker style="width: 100%" nzAllowClear="false" name="updatedDate" nzFormat="dd/MM/yyyy"
                        [(ngModel)]="WORKED_DATETIMEs" [nzDisabledDate]="disableFuterDates"
                        (ngModelChange)="searchworklog()">
                      </nz-date-picker>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div style="text-align: center" *ngIf="isWorklogSpinning">
                <nz-spin nzSimple></nz-spin>
              </div>
              <nz-divider style="margin: 10px 0px !important"></nz-divider>
              <div *ngIf="!isWorklogSpinning">
                <div nz-row *ngIf="worklogcount > 0">
                  <div nz-col nzSpan="24" style="
                      border: solid 1px rgb(228 228 228);
                      border-radius: 10px;
                      margin-bottom: 10px;
                      padding: 3px;
                      background: white;
                    " *ngFor="let worklog of worklogData">
                    <div nz-row>
                      <div nz-col nzSpan="24" style="display: inline-flex">
                        <div>
                          <nz-avatar [nzText]="USER_NAME" style="
                              color: red;
                              background-color: rgb(247, 218, 218);
                              margin-top: 5px;
                            ">
                          </nz-avatar>
                        </div>
                        <div style="margin-left: 10px">
                          <div>
                            <p style="
                                font-size: 11px;
                                margin-bottom: 0px;
                                color: rgb(134 110 255);
                                font-weight: 600;
                              ">
                              {{ worklog.PROJECT_NAME }}
                            </p>
                          </div>
                          <div>
                            <p (click)="showWorklogModal(worklog)" style="
                                cursor: pointer;
                                font-size: 14px;
                                margin-bottom: 0px;
                              ">
                              {{ worklog.WORK_DESCRIPTION }}
                            </p>
                          </div>
                          <div style="cursor: pointer; font-size: 12px">
                            <span>
                              Working Time :
                              {{ worklog.START_DATETIME | date : "hh:mm a" }}
                              - {{ worklog.END_DATETIME | date : "hh:mm a" }}
                            </span>
                            <span style="margin-left: 50px">
                              Total Hours : {{ worklog.SPENT_HOURS }}hrs
                              {{ worklog.SPENT_MINUTES }}min
                              {{ worklog.SPENT_SECONDS }}sec</span>
                          </div>

                          <div style="margin-top: 5px">
                            <a *ngIf="worklog.USER_ID == loggedUserID" (click)="editWorklog(worklog)" style="
                                color: rgb(19, 81, 196);
                                font-size: 12px;
                                font-weight: 600;
                              ">Edit</a>

                            <a *ngIf="worklog.USER_ID == loggedUserID" style="
                                color: #d70027;
                                margin-left: 10px;
                                font-size: 12px;
                                font-weight: 600;
                              " nz-popconfirm nzPopconfirmTitle="Are you sure delete this Work log?"
                              nzPopconfirmPlacement="bottom" (nzOnConfirm)="handleConfirmForWorklog(worklog)"
                              (nzOnCancel)="handleCancelForWorklog()">
                              Delete
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div nz-col nzSpan="24" *ngIf="worklogcount > 0">
                  <div style="text-align: center">
                    <button nz-button nzType="primary" [nzLoading]="isWorklogLoadMoreButtonSpinning"
                      [hidden]="isWorklogLoadMoreButtonHide" (click)="loadMoreWorklogIDWise()">
                      <i nz-icon nzType="plus"></i>Load More
                    </button>
                  </div>
                </div>
                <div *ngIf="worklogcount == 0" style="height: 266px">
                  <div style="text-align: center">
                    <br />
                    <svg xmlns="http://www.w3.org/2000/svg" width="140" height="100">
                      <defs>
                        <linearGradient x1="52.348%" y1="74.611%" x2="52.348%" y2="-17.635%" id="a">
                          <stop stop-color="#DEDEDE" stop-opacity="0" offset="0%" />
                          <stop stop-color="#A9A9A9" stop-opacity=".3" offset="100%" />
                        </linearGradient>
                        <linearGradient x1="44.79%" y1="100%" x2="44.79%" y2="0%" id="b">
                          <stop stop-color="#FFF" stop-opacity="0" offset="0%" />
                          <stop stop-color="#96A1C5" stop-opacity=".373" offset="100%" />
                        </linearGradient>
                        <linearGradient x1="50%" y1="100%" x2="50%" y2="-19.675%" id="c">
                          <stop stop-color="#FFF" stop-opacity="0" offset="0%" />
                          <stop stop-color="#919191" stop-opacity=".15" offset="100%" />
                        </linearGradient>
                        <linearGradient x1="50%" y1="0%" x2="50%" y2="44.95%" id="d">
                          <stop stop-color="#5389F5" offset="0%" />
                          <stop stop-color="#416FDC" offset="100%" />
                        </linearGradient>
                        <linearGradient x1="63.345%" y1="100%" x2="63.345%" y2="-5.316%" id="e">
                          <stop stop-color="#DCE9FF" offset="0%" />
                          <stop stop-color="#B6CFFF" offset="100%" />
                        </linearGradient>
                        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="f">
                          <stop stop-color="#7CA5F7" offset="0%" />
                          <stop stop-color="#C4D6FC" offset="100%" />
                        </linearGradient>
                      </defs>
                      <g transform="translate(-1.866 .364)" fill="none" fill-rule="evenodd">
                        <path
                          d="M27.94 14.864c1.326-4.192 2.56-6.802 3.7-7.831 3.157-2.848 7.522-1.298 8.45-1.076 3.26.782 2.2-4.364 4.997-5.41 1.864-.697 3.397.155 4.6 2.556C50.752.863 52.375-.163 54.556.02c3.272.277 4.417 11.328 8.913 8.909 4.497-2.42 10.01-2.973 12.365.623.509.778.704-.429 4.166-4.55C83.462.88 86.914-.936 93.996 1.464c3.22 1.09 5.868 4.045 7.947 8.864 0 6.878 5.06 10.95 15.178 12.213 15.179 1.895 3.397 18.214-15.178 22.993-18.576 4.78-61.343 7.36-84.551-4.716C1.92 32.769 5.436 24.117 27.939 14.864z"
                          fill="url(#a)" opacity=".8" />
                        <ellipse fill="url(#b)" cx="66" cy="69.166" rx="27.987" ry="6.478" />
                        <path
                          d="M113.25 77.249c-21.043 5.278-92.87-.759-100.515-3.516-3.721-1.343-7.075-3.868-10.061-7.576a2.822 2.822 0 0 1 2.198-4.593h125.514c2.605 6.938-3.107 12.166-17.136 15.685z"
                          fill="url(#c)" opacity=".675" />
                        <g fill-rule="nonzero">
                          <path
                            d="M43.396 12.098L33.825.906a2.434 2.434 0 0 0-1.837-.86h-20.58c-.706 0-1.377.324-1.837.86L0 12.098v6.144h43.396v-6.144z"
                            fill="url(#d)" transform="translate(44.08 39.707)" />
                          <path
                            d="M40.684 18.468L32.307 8.72a2.136 2.136 0 0 0-1.622-.725H12.711c-.617 0-1.22.256-1.622.725l-8.377 9.748v5.354h37.972v-5.354z"
                            fill="url(#e)" transform="translate(44.08 39.707)" />
                          <path
                            d="M43.396 25.283c0 .853-.384 1.62-.99 2.134l-.123.1a2.758 2.758 0 0 1-1.67.56H2.784c-.342 0-.669-.062-.971-.176l-.15-.06A2.802 2.802 0 0 1 0 25.282V12.165h10.529c1.163 0 2.1.957 2.1 2.118v.015c0 1.162.948 2.099 2.111 2.099h13.916a2.113 2.113 0 0 0 2.111-2.107c0-1.166.938-2.125 2.1-2.125h10.53z"
                            fill="url(#f)" transform="translate(44.08 39.707)" />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p style="
                      font-weight: bold;
                      color: #666666;
                      font-size: medium;
                      text-align: center;
                    ">
                    Work logs Not Found
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nz-spin>

<nz-modal [nzBodyStyle]="{ height: '400px', 'padding-top': '15px' }" [(nzVisible)]="isWorklogVisible"
  [nzTitle]="worklogModalName" nzWidth="30%" (nzOnCancel)="handleWorklogCancel()" [nzFooter]="null">
  <ng-container *nzModalContent>
    <div nz-row>
      <div nz-col nzSpan="24">
        <b>Worklog Author : </b>
        <div style="text-align: center" *ngIf="isWorklogAuthorUserLoading">
          <nz-spin nzSimple></nz-spin>
        </div>
        <div *ngIf="!isWorklogAuthorUserLoading">
          <nz-tag [nzColor]="'#87d068'">
            {{ worklogAuthor }}
          </nz-tag>
        </div>
      </div>

      <nz-divider nzText="" style="margin: 12px 0px !important"></nz-divider>

      <div nz-col nzSpan="12">
        <b>Start Datetime : </b><br />
        {{ worklogStartDateTime | date : "dd MMM, yyyy hh:mm a" }}
      </div>

      <div nz-col nzSpan="12">
        <b>End Datetime : </b><br />
        {{ worklogEndDateTime | date : "dd MMM, yyyy hh:mm a" }}
      </div>

      <nz-divider nzText="" style="margin: 12px 0px !important"></nz-divider>

      <div nz-col nzSpan="24">
        <b>Spent Time : </b><br />
        {{ worklogSpentTime }}
      </div>

      <nz-divider nzText="" style="margin: 12px 0px !important"></nz-divider>

      <div nz-col nzSpan="24">
        <b>Description : </b><br />
        {{ worklogDescription }}
      </div>
    </div>
  </ng-container>
</nz-modal>

<div *ngIf="modalForSubtask">
  <nz-drawer [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px',
      'padding-top': '10px',
      'padding-right': '10px',
      'padding-left': '10px'
    }" [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzVisible]="modalForSubtask"
    [nzTitle]="'Add New Sub Task'" nzWidth="450px" (nzOnClose)="handleCancel()" (nzKeyboard)="(true)">
    <ng-container *nzDrawerContent>
      <nz-spin [nzSpinning]="loadingsubtask">
        <div nz-row>
          <div nz-col nzSpan="24">
            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label nzRequired nzNoColon>Sub Task Name</nz-form-label>
                  <nz-form-control>
                    <input nz-input autocomplete="off" name="subtaskNameww" type="text"
                      placeHolder="Enter a Sub Task Name" [(ngModel)]="SUBTASK_NAME" required />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label nzNoColon>Sub Task Description</nz-form-label>
                  <nz-form-control>
                    <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 3 }" name="subtaskDescriptionw"
                      placeHolder="Enter a Sub Task  Description" [(ngModel)]="SUBTASK_DESCRIPTION"></textarea>
                  </nz-form-control>
                  <span style="font-size: 10px; color: red" *ngIf="SUBTASK_DESCRIPTION != undefined">{{
                    SUBTASK_DESCRIPTION.length }}/ 500</span>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="24">
                <nz-form-item>
                  <div style="display: flex; justify-content: space-between">
                    <nz-form-label nzRequired nzNoColon>Assignee</nz-form-label>
                    <div style="display: flex; align-items: center">
                      Select All &nbsp;
                      <nz-switch name="isSelectAllAssignee" [(ngModel)]="AllAssignee"
                        (ngModelChange)="selectAllAssignee()" nzCheckedChildren="On"
                        nzUnCheckedChildren="Off"></nz-switch>
                    </div>
                  </div>
                  <nz-form-control>
                    <nz-select name="subtaskAssigneeName" nzMode="multiple" nzShowSearch nzAllowClear
                      nzPlaceHolder="Select Assignee" [(ngModel)]="SUBTASK_ASSIGNEE_ID">
                      <nz-option nzCustomContent *ngFor="let assignee of newAssigneeList" [nzValue]="assignee.USER_ID"
                        [nzLabel]="assignee.USER_NAME">
                        <div>
                          {{ assignee.USER_NAME }}
                        </div>
                        <div style="
                            font-size: 12px;
                            color: gray;
                            text-align: right;
                          ">
                          <span>~&nbsp;{{ assignee.TASK_CATEGORY_NAME }} ({{
                            assignee.ROLE_NAME
                            }})</span>
                        </div>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label nzRequired nzNoColon>Sub Task Category</nz-form-label>
                  <nz-form-control>
                    <nz-select name="subtaskCategory" nzShowSearch nzAllowClear="false"
                      [nzLoading]="isSubtaskCategoryLoading" nzPlaceHolder="Select a Sub Task  Category"
                      [(ngModel)]="SUBTASK_CATEGORY_ID">
                      <nz-option *ngFor="let category of categoryList" [nzValue]="category.ID"
                        [nzLabel]="category.NAME">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="8">
                <nz-form-item>
                  <nz-form-label nzRequired nzNoColon>Sub Task Priority</nz-form-label>
                  <nz-form-control>
                    <nz-select name="subtaskPriority" nzShowSearch nzAllowClear="false"
                      nzPlaceHolder="Select a Priority" [(ngModel)]="SUBTASK_PRIORITY">
                      <nz-option nzLabel="Critical" nzValue="C"></nz-option>
                      <nz-option nzLabel="High" nzValue="ME"></nz-option>
                      <nz-option nzLabel="Medium" nzValue="MD"></nz-option>
                      <nz-option nzLabel="Low" nzValue="L"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="8">
                <nz-form-item>
                  <nz-form-label nzNoColon>Start Date</nz-form-label>
                  <nz-form-control>
                    <nz-date-picker #subtaskStartDatePicker style="width: 100%; padding: 4px 6px !important"
                      nzFormat="dd/MM/yyyy" [nzDisabledDate]="disabledDateprevious" name="subtaskStartDaste"
                      (nzOnOpenChange)="subtaskStartDateHandle($event)"
                      [(ngModel)]="SUBTASK_START_DATE"></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="8">
                <nz-form-item>
                  <nz-form-label nzNoColon>End Date</nz-form-label>
                  <nz-form-control>
                    <nz-date-picker #subtaskEndDatePicker style="width: 100%; padding: 4px 6px !important"
                      nzFormat="dd/MM/yyyy" name="sdubtaskEndDate" [nzDisabledDate]="disabledSubtaskEndDate"
                      [(ngModel)]="SUBTASK_END_DATE"></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="16">
                <nz-form-item>
                  <nz-form-label nzNoColon>Estimated Time</nz-form-label>
                  <div style="display: inline-flex">
                    <nz-form-control>
                      <input nz-input name="subtaskEstimatedHours" type="number" min="0"
                        oninput="this.value = Math.abs(this.value)" placeHolder="HH"
                        [(ngModel)]="SUBTASK_ESTIMATED_HOURS" required />
                    </nz-form-control>

                    <nz-form-control>
                      <input nz-input name="subtaskEstimatedMinutes" type="number" min="0"
                        oninput="this.value = Math.abs(this.value)" placeHolder="MM"
                        [(ngModel)]="SUBTASK_ESTIMATED_MINUTES" required />
                    </nz-form-control>

                    <nz-form-control>
                      <input nz-input name="subtaskEstimatedSeconds" type="number" min="0"
                        oninput="this.value = Math.abs(this.value)" placeHolder="SS"
                        [(ngModel)]="SUBTASK_ESTIMATED_SECONDS" required />
                    </nz-form-control>
                  </div>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>
      </nz-spin>
      <div class="footer">
        <button nz-button nzType="default" style="margin-right: 8px" [nzLoading]="loadingsubtask"
          (click)="handleCancel()">
          Cancel
        </button>
        <button nz-button nzType="primary" (click)="handleOk(false)" [nzLoading]="loadingsubtask"
          style="margin-right: 0px" nz-button nz-dropdown [nzDropdownMenu]="menu">
          Save & Close
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px; background-color: #40a9ff">
              <a style="color: white" (click)="handleOk(true)">Save & New</a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </ng-container>
  </nz-drawer>
</div>